var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAltLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 12.8333C14.9667 12.8333 15.7502 12.0498 15.7502 11.0833C15.7502 10.1168 14.9667 9.33325 14.0002 9.33325C13.0337 9.33325 12.2502 10.1168 12.2502 11.0833C12.2502 12.0498 13.0337 12.8333 14.0002 12.8333Z",
    fill: "#0A1419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.33325C11.5407 2.33313 9.18076 3.30364 7.43308 5.03384C5.6854 6.76405 4.69122 9.11411 4.66663 11.5733C4.66663 17.9666 12.8916 25.0833 13.2416 25.3866C13.4529 25.5673 13.7219 25.6667 14 25.6667C14.278 25.6667 14.547 25.5673 14.7583 25.3866C15.1666 25.0833 23.3333 17.9666 23.3333 11.5733C23.3087 9.11411 22.3145 6.76405 20.5668 5.03384C18.8192 3.30364 16.4592 2.33313 14 2.33325ZM14 15.1666C13.1924 15.1666 12.4029 14.9271 11.7314 14.4784C11.0599 14.0297 10.5365 13.392 10.2275 12.6459C9.91839 11.8997 9.83753 11.0787 9.99509 10.2866C10.1526 9.49454 10.5415 8.76696 11.1126 8.1959C11.6837 7.62484 12.4113 7.23594 13.2033 7.07838C13.9954 6.92082 14.8165 7.00169 15.5626 7.31074C16.3087 7.6198 16.9464 8.14317 17.3951 8.81467C17.8438 9.48617 18.0833 10.2756 18.0833 11.0833C18.0833 12.1662 17.6531 13.2048 16.8873 13.9706C16.1215 14.7364 15.0829 15.1666 14 15.1666Z",
    fill: "#0A1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAltLarge);
export default __webpack_public_path__ + "static/media/pin_alt_large.ef2822bcb80474e827b4deabe9843a8a.svg";
export { ForwardRef as ReactComponent };